<mat-card class="bg-white">
  <mat-card-header class="border-b border-red-500 p-2 bg-red-50">
    <mat-card-title class="text-red-500 text-xl ">Error(s)</mat-card-title>
  </mat-card-header>
  @if (errorMessage) {
  <mat-card-content class="p-5">
    <div> {{errorMessage}} </div>
  </mat-card-content>
  }
  @if (errorMessageList && errorMessageList.length > 0) {
  <!-- <mat-card-content class="p-2">
    @for (errorMessage of errorMessageList; track errorMessage) {
    <div> {{errorMessage}} </div>
    }
  </mat-card-content> -->
  <div class="p-0">
  <div class="p-2 grid grid-cols-1 gap-2">
    @for (error of errorMessageList; track error) {
      <div mat-ripple class="cursor-default flex items-center justify-between p-4 w-full bg-white border border-gray-200 rounded-lg hover:border-blue-500 hover:shadow-md transition-all text-left group">
        <div class="flex flex-col">
          <span class="text-sm font-semibold text-gray-800 group-hover:text-blue-600">
            {{ error }}
          </span>
        </div>
      </div>
    }
  </div>
</div>
  }
  <mat-card-footer>

  </mat-card-footer>
</mat-card>